
export const RECEIVE = 'userAccount/RECEIVE';
export const RECEIVE_ROLES = 'userAccount/RECEIVE_ROLES';
